import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Base from './../core/Base';
import { signup } from '../apiCallsHelper/authapicalls';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import todoSignupImage from "../images/todo-signup-pic.jpg"
import todoLogoDark from "../images/TodoMate-logo-dark.png"
import LoadingOverlay from './../utils/LoadingOverlay';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import "../styles.css";




const Signup = () => {

    const navigate = useNavigate();

    const [values, setValues] = useState({
        fname: "",
        lname: "",
        email: "",
        password: "",
        isLoading: false,
    });

    const { fname, lname, email, password } = values;

    const [isLoading, setIsLoading] = useState(false);

    const [showPassword, setShowPassword] = useState(false);





    const handleChange = name => event => {
        setValues({ ...values, [name]: event.target.value });
    }


    const togglePasswordType = (event) => {
        event.preventDefault();
        setShowPassword(!showPassword);
    }


    const onSubmit = event => {
        event.preventDefault();
        setValues({ ...values })
        setIsLoading(true);
        signup({ fname, lname, email, password })
            .then(data => {
                if (data.error) {
                    toast.error(data.error, {
                        theme: "colored",
                    });

                    setIsLoading(false);
                    setValues({ ...values })
                }
                else {
                    toast.success(data.message, {
                        theme: "colored",
                    });
                    setIsLoading(false);
                    setValues({
                        ...values,
                        fname: "",
                        lname: "",
                        email: "",
                        password: "",
                    });
                    navigate("/verify-account")
                }
            })
    }



    return (
        <Base bgClass="bg-[#e8eefa]">
            <div className="bg-[#e8eefa]  pt-8 pb-8   sm:pt-12 sm:pb-4    md:pt-8 md:pb-6  smLaptop:pt-4 smLaptop:pb-2  lg:pt-2 lg:pb-6   xl:pt-2 xl:pb-8 ">
                <div className="flex bg-white rounded-lg shadow-lg overflow-hidden mx-auto max-w-sm  md:max-w-2xl smLaptop:max-w-2xl  lg:max-w-4xl ">
                    <div className="hidden md:block md:w-1/2  lg:block lg:w-1/2" >
                        <img src={todoSignupImage} alt="todo" className='w-full  h-full' />
                    </div>

                    {isLoading && <LoadingOverlay />}

                    <div className="w-full px-8 pb-14 pt-8 md:w-1/2 lg:w-1/2 lg:pt-8  xl:pt-12  ">
                        <div className="flex  justify-center">
                            <img src={todoLogoDark} alt="todo" className='   h-[60px]   xs:h-[60px]  sm:h-[50px]  md:h-[60px]  smLaptop:h-[60px]  lg:h-[65px]  xl:h-[65px]  ' />
                        </div>
                        <p className=" mt-2    text-xl text-gray-600 text-center ">Welcome!</p>
                        <div className="   mt-6 sm:mt-2 md:mt-2 flex items-center justify-between">
                            <span className="border-b w-1/5 lg:w-1/4"></span>
                            <p className="text-xs text-center text-gray-500 uppercase">Signup here</p>
                            <span className="border-b w-1/5 lg:w-1/4"></span>
                        </div>
                        <div className="mt-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">First name</label>
                            <input onChange={handleChange("fname")} value={fname} type="text" className="bg-[#e8edfa] text-gray-700 focus:outline-[#7b9de3]  border border-gray-300 rounded py-2 pl-2 pr-1 block w-full appearance-none" placeholder="Enter your firstname" required />
                        </div>
                        <div className="mt-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">Last name</label>
                            <input onChange={handleChange("lname")} value={lname} type="text" className=" bg-[#e8edfa] text-gray-700 focus:outline-[#7b9de3]  border border-gray-300 rounded py-2 pl-2 pr-1 block w-full appearance-none" placeholder="Enter your lastname" />
                        </div>
                        <div className="mt-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">Email address</label>
                            <input onChange={handleChange("email")} value={email} type="email" className="bg-[#e8edfa] text-gray-700 focus:outline-[#7b9de3]  border border-gray-300 rounded py-2 pl-2 pr-1 block w-full appearance-none" placeholder="Enter your email address" required />
                        </div>
                        <div className="mt-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">Password</label>
                            <div className='flex w-full'>
                                <input onChange={handleChange("password")} value={password} type={showPassword ? "text" : "password"}  className="bg-[#e8edfa] text-gray-700 focus:outline-[#7b9de3]  border border-gray-300 rounded py-2 pl-2 pr-1 block w-full appearance-none" placeholder="Enter password" required />
                                <button type="button" onClick={togglePasswordType}>
                                    {showPassword ?
                                        (
                                            <FontAwesomeIcon icon={faEye} className='ml-[-30px] mt-2' size='sm' color='#7292f7' />
                                        ) : (
                                            <FontAwesomeIcon icon={faEyeSlash} className='ml-[-30px] mt-2' size='sm' color='#7292f7' />
                                        )}
                                </button>
                            </div>
                        </div>
                        <div className="mt-10">
                            <button onClick={onSubmit} className="hover:bg-green-700 text-white font-bold py-2 px-4 w-full rounded bg-[#24a34a]">
                                Signup
                            </button>
                        </div>
                        <div className="text-xs mt-8">
                            Already have an account? <Link className="text-blue-500 hover:underline" to="/signin">Login</Link>
                        </div>
                    </div>
                </div>
            </div>
        </Base>
    )
}




export default Signup;